<template>
  <div class="school-admin">
    <div class="school-admin-header">
      <el-button type="primary" @click="addSchool">创建学校</el-button>
    </div>
    <el-table class="customTable" :data="schoolList"
              style="width: 100%; margin-top: 20px; flex: 1;" height="1%" size="medium"
              :header-cell-style="{fontWeight: 'normal', height: '60px', color: '#666666', background: '#F6F6F6',fontSize: '16px'}"
              :cell-style="{fontSize: '16px',color: '#333333',height: '70px'}">
      <el-table-column prop="name" align="center" label="学校名称"></el-table-column>
      <el-table-column prop="" align="center" label="LOGO">
        <template slot-scope="scope">
          <div class="column-logo-box">
            <div class="column-logo">
              <img v-if="scope.row.avatar" :src="scope.row.avatar" alt="">
              <img v-else src="./../../../assets/images/admin/school-default.png" alt="">
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" align="center" label="创建时间"></el-table-column>
      <el-table-column align="center" label="操作" width="500">
        <template slot-scope="scope">
          <el-link type="success" :underline="false" @click="allotClick(scope.row,1)">分配课程</el-link>
          <el-link type="success" :underline="false" @click="allotClick(scope.row,2)">分配实操题</el-link>
          <el-link type="success" :underline="false" @click="allotClick(scope.row,3)">分配理论题试卷</el-link>
          <el-link type="success" :underline="false" @click="allotClick(scope.row,4)">分配试卷</el-link>
          <el-link type="success" :underline="false" @click="editSchool(scope.row)">编辑</el-link>
          <el-link type="primary" :underline="false" @click="deleteSchool(scope.row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <!--   创建编辑学校dialog   -->
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="dialogTitle"
        custom-class="green-dialog"
        :visible.sync="schoolDialogVisible"
        @close="resetForm"
        @opened="openAddSchool"
        width="500px">
      <el-form ref="addSchoolForm" :model="addSchoolForm" :rules="addSchoolRules" label-position="top">
        <el-form-item label="学校名称" prop="name">
          <el-input v-model="addSchoolForm.name" ref="cursorInput" placeholder="2-26"></el-input>
        </el-form-item>
        <el-form-item label="LOGO">
          <div class="logo-src-box" v-if="addSchoolForm.avatar">
            <img :src="logoSrc" alt="">
            <i @click="clearLogo" class="iconfont">&#xe651;</i>
          </div>
          <el-upload class="logo-uploader"
                     v-else
                     action="school/upload"
                     :headers="headersParams"
                     name="avatar"
                     :show-file-list="false"
                     :on-success="handleCoverSuccess"
                     :before-upload="beforeCoverUpload">
            <i class="el-icon-plus logo-uploader-icon"></i>
          </el-upload>
          <span class="school-prompt">建议尺寸：200*200；格式为.jpg或.jpeg或.png；大小不超过2M的图片</span>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="schoolDialogVisible = false">取 消</el-button>
        <el-button style="margin-left: 30px" type="primary" @click="confirmForm('addSchoolForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--   分配实操、理论、课程、试卷   -->
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="allotTitle"
        custom-class="green-dialog"
        :visible.sync="allotDialogVisible"
        @close="allotCloseDialog"
        @opened="openAllot"
        width="650px">
      <el-cascader-panel :class="panelClassValue === 1 ? 'allot-class' : 'allot-class-two'" :props="allotProps"
                         v-model="allocationValue" :options="allotList"></el-cascader-panel>
      <div class="dialog-footer">
        <el-button @click="allotDialogVisible = false">取 消</el-button>
        <el-button style="margin-left: 30px" type="primary" @click="confirmAllocation">确 定</el-button>
      </div>
    </el-dialog>
    <el-pagination class="pager-center" style="margin: 20px 0 30px;text-align: center"
                   :current-page="schoolPages.currentPageNum"
                   :page-size="schoolPages.eachPageNum"
                   :total="schoolPages.total"
                   layout="prev, pager, next, jumper"
                   @current-change="schoolCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import {
  adminSchoolSchools,
  adminSchoolAdd,
  adminSchoolInfo,
  adminSchoolDel,
  cate,
  assignTopics,
  assignTopic,
  assignExampapers,
  assignPapers,
  assignPaper,
  assignList,
  assignCourses,
  assignCourse
} from '@/utils/apis'

export default {
  name: "Index",
  data() {
    return {
      schoolList: [],
      schoolPages: {
        currentPageNum: 1,
        eachPageNum: 10,
        total: 0,
      },
      dialogTitle: '',
      schoolDialogVisible: false,
      addSchoolForm: {
        id: '',
        name: '',
        avatar: ''
      },
      logoSrc: null,
      addSchoolRules: {
        name: [
          {required: true, message: '请输入学校名称', trigger: 'blur'},
          {min: 2, max: 26, message: '长度在 2 到 26 个字', trigger: 'blur'}
        ]
      },
      headersParams: {
        Authorization: localStorage.getItem('adminToken') || ''
      },
      allotTitle: '',
      allotDialogVisible: false,
      allocationValue: '',
      allotList: [],
      allotProps: {value: 'id', label: 'name', multiple: true},
      panelClassValue: 1, //控制二级  三级样式
      hostUrl: localStorage.getItem('hosturl') || '',
      questionsClassList: [], //实操 理论分类
      paperClassList: [], // 试卷分类
      courseClassList: [], // 课程分类
      isAllocationConfirm: null, //分配的类型 1.课程 2.实操 3.理论 4.试卷
      isAllocationSchoolId: '', // 分配学校的id
    }
  },
  mounted() {
    this.getSchoolList();
    this.getQuestionsClassList();
    this.getAssignList();
  },
  methods: {
    // 确定分配
    confirmAllocation() {
      // 如果分配的是理论和实操
      if (this.panelClassValue === 1) {
        if(this.isAllocationConfirm !== 4){
          let list = [];
          if (this.allocationValue.length) {
            this.allocationValue.forEach(item => {
              list.push(item[item.length - 1])
            })
          }
          let ids = list.join(',')
          let formData = new FormData();
          formData.append('school_id', this.isAllocationSchoolId);
          formData.append('ids', ids);
          // 理论传1 实操传2
          if (this.isAllocationConfirm === 2) {
            formData.append('type', 2)
          } else {
            formData.append('type', 1)
          }
          assignTopic(formData).then((res) => {
            this.$message({
              message: res.msg,
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.allotDialogVisible = false;
                this.getSchoolList()
              }
            })
          }).catch((err) => {
            console.log('err', err)
          })
        } else {
          // 如果分配的是试卷
          let list = [];
          if (this.allocationValue.length) {
            this.allocationValue.forEach(item => {
              list.push(item[item.length - 1])
            })
          }
          let ids = list.join(',');
          let formData = new FormData();
          formData.append('school_id', this.isAllocationSchoolId);
          formData.append('ids', ids);
          assignPaper(formData).then((res) => {
            this.$message({
              message: res.msg,
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.allotDialogVisible = false;
                this.getSchoolList()
              }
            })
          }).catch((err) => {
            console.log('err', err)
          })
        }
      } else {
        if (this.isAllocationConfirm === 1) {
          //如果分配的是课程
          let list = [];
          if (this.allocationValue.length) {
            // 转换成接口所需格式
            this.allocationValue.forEach(item => {
              let obj = {
                course_id:item[0],
                chapter_ids:[]
              }
              list.push(obj)
            })
            // 去重
            let hash = {};
            list = list.reduce((item,next)=>{
              hash[next.course_id] ? "" : hash[next.course_id] = true && item.push(next);
              return item
            },[]);
            this.allocationValue.forEach(item=>{
              list.forEach(listItem=>{
                if(item[0] === listItem.course_id){
                  listItem.chapter_ids.push(item[item.length - 1])
                }
              })
            })
          }
        let params = {
          school_id:this.isAllocationSchoolId,
          ids:list
        }
        assignCourse(params).then((res)=>{
          this.$message({
            message: res.msg,
            type: 'success',
            duration: 1000,
            onClose: () => {
              this.allotDialogVisible = false;
              this.getSchoolList()
            }
          })
        }).catch((err)=>{
          console.log('err', err)
        })
        }
      }
    },
    // 获取课程分类列表
    getAssignList(){
      assignList().then((res)=>{
        this.courseClassList = res.data;
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    //获取理论、实操分类,试卷分类列表
    getQuestionsClassList() {
      let param = {
        type: '3'
      }
      cate(param).then((res) => {
        this.questionsClassList = res.data;
      }).catch((err) => {
        console.log('err', err);
      });
    },
    getSchoolList() {
      let params = {
        limit: this.schoolPages.eachPageNum,
        page: this.schoolPages.currentPageNum
      }
      adminSchoolSchools(params).then((res) => {
        this.schoolList = res.data.list;
        this.schoolPages.total = res.data.total;
      }).catch((err) => {
        console.log('err', err)
      })
    },
    addSchool() {
      this.dialogTitle = '创建学校';
      this.schoolDialogVisible = true;
    },
    // 获取分配
    allotClick(row, num) {
      this.isAllocationConfirm = num;
      this.isAllocationSchoolId = row.id;
      if (num === 1) {
        this.allotTitle = '分配课程';
        this.allotList = JSON.parse(JSON.stringify(this.courseClassList));
        this.panelClassValue = 2;
        let params = {
          school_id:row.id
        }
        assignCourses(params).then((res)=>{
          this.allocationValue = res.data;
        }).catch((err)=>{
          console.log('err', err)
        })
      } else if (num === 2 || num === 3) {
        this.allotTitle = num === 2 ? '分配实操题' : '分配理论题试卷';
        let type = num === 2 ? 2 : 1
        this.allotList = JSON.parse(JSON.stringify(this.questionsClassList));
        this.panelClassValue = 1;
        let params = {
          school_id: row.id,
          type: type
        }
        assignTopics(params).then((res) => {
          if (res.data.length) {
            this.allocationValue = res.data;
          }
        }).catch((err) => {
          console.log('err', err)
        })
      } else if (num === 4) {
        this.allotTitle = '分配试卷';
        this.allotList = JSON.parse(JSON.stringify(this.questionsClassList));
        this.panelClassValue = 1;
        let params = {
          school_id: row.id
        }
        assignPapers(params).then((res) => {
          this.allocationValue = res.data;
          console.log(this.allocationValue)
        }).catch((err) => {
          console.log('err', err)
        })
      }
      this.allotDialogVisible = true;
    },
    editSchool(row) {
      this.addSchoolForm.id = row.id;
      this.dialogTitle = '编辑学校';
      this.schoolDialogVisible = true
    },
    deleteSchool(row) {
      this.$confirm(`是否删除该学校，删除将无法恢复`, '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'green-message-box',
        type: 'warning'
      }).then(() => {
        adminSchoolDel(row.id).then((res) => {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: 1000,
            onClose: () => {
              this.getSchoolList()
            }
          })
        }).catch((err) => {
          console.log('err', err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    resetForm() {
      this.$refs.addSchoolForm.resetFields();
      this.logoSrc = null;
      this.addSchoolForm.avatar = '';
      this.addSchoolForm.id = '';
    },
    allotCloseDialog() {
      this.allocationValue = ''
      // this.allotList = []
    },
    openAddSchool() {
      if (this.addSchoolForm.id) {
        adminSchoolInfo(this.addSchoolForm.id).then((res) => {
          this.addSchoolForm.name = res.data.name;
          this.addSchoolForm.avatar = res.data.avatar;
          this.logoSrc = this.hostUrl + res.data.avatar;
        }).catch((err) => {
          console.log('err', err)
        })
      }
      this.$refs.cursorInput.focus();
    },
    openAllot() {

    },
    // start 上传图片
    beforeCoverUpload(file) {
      const isImg = file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.png');
      if (!isImg) {
        this.$message.error('上传图片只能是 jpg 或 jpeg 或 png 格式!');
        return false;
      }
      return isImg;
    },
    // 上传图片
    handleCoverSuccess(res, file) {
      if (res.code === 200) {
        this.logoSrc = this.hostUrl + res.data.src; // 有域名
        this.addSchoolForm.avatar = res.data.src; //无域名
        this.$message.success('头像上传成功')
      } else {
        this.$message.error('头像上传失败，请稍后再试~')
      }
    },
    // 删除logo
    clearLogo() {
      this.logoSrc = null;
      this.addSchoolForm.avatar = '';
    },
    confirmForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData();
          formData.append('name', this.addSchoolForm.name);
          formData.append('avatar', this.addSchoolForm.avatar);
          if (this.addSchoolForm.id) {
            formData.append('id', this.addSchoolForm.id)
          }
          adminSchoolAdd(formData).then((res) => {
            this.$message({
              message: res.msg,
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.schoolDialogVisible = false;
                this.getSchoolList()
              }
            })
          }).catch((err) => {
            console.log('err', err)
          })
        } else {
          return false;
        }
      })
    },
    schoolCurrentChange(val) {
      this.schoolPages.currentPageNum = val;
      this.getSchoolList();
    }
  }
}
</script>

<style scoped lang="scss">
.school-admin {
  padding: 0px 20px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;

  .school-admin-header {
    display: flex;
    justify-content: flex-end;
  }
}

.logo-uploader {
  ::v-deep.el-upload {
    width: 80px;
    height: 80px;
    background: #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo-uploader-icon {
      font-size: 32px;
      color: #A0A0A0;
    }
  }
}

.logo-src-box {
  width: 80px;
  height: 80px;
  box-sizing: border-box;
  border: 1px solid #EEEEEE;
  position: relative;

  img {
    max-width: 100%;
    max-height: 100%;
  }

  i {
    line-height: 1;
    font-size: 14px;
    color: #DCDCDC;
    position: absolute;
    right: -20px;
    top: 0;
    cursor: pointer;
  }
}

.school-prompt {
  color: #999;
  font-size: 12px;
}

::v-deep .green-dialog {
  .el-dialog__body {
    padding: 22px 24px;

    .el-form-item {
      margin-bottom: 26px;
    }

    .el-form-item__label {
      padding: 0;
      line-height: 1;
      font-size: 16px;
      color: #333333;
      margin-bottom: 10px;
    }

    .dialog-footer {
      text-align: center;
      margin-top: 20px;
    }

    .allot-class, .allot-class-two {
      &.allot-class-two .el-cascader-menu {
        width: 50%;

        &:last-of-type {
          border-right: none;
        }
      }

      &.allot-class .el-cascader-menu {
        width: calc(100% / 3);

        &:nth-child(3) {
          border-right: none;
        }
      }

      .el-cascader-menu {
        border-right: 1px solid #E4E7ED;

        .el-cascader-menu__wrap {
          height: 286px;

          .el-cascader-menu__list {
            .el-cascader-node {
              &:hover {
                background: #FEECEC;
              }
            }
          }
        }
      }
    }
  }
}

.column-logo-box {
  display: flex;
  align-items: center;
  justify-content: center;

  .column-logo {
    width: 48px;
    height: 48px;
    border: 1px solid #EEEEEE;
    border-radius: 10px;
    overflow: hidden;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

</style>